import { inject, Injectable } from '@angular/core';

import { HttpService } from '@bbraun/helpex/src/lib/http';
import { environment } from '@environment/environment';
import { LightProtectionReference } from '@shared/interfaces/light-protection-reference/light-protection-reference.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LightProtectionReferencesService {
  private readonly httpService = inject(HttpService);
  private readonly referenceRoute = 'lightProtectionReferences';

  public getReferences(): Observable<Array<LightProtectionReference>> {
    return this.httpService.request(this.referenceRoute).get(environment.backendUrl);
  }

  public getReferenceById(referenceId: number): Observable<LightProtectionReference> {
    return this.httpService
      .request(`${this.referenceRoute}/${referenceId}`)
      .get(environment.backendUrl);
  }

  public postReference(
    reference: Omit<LightProtectionReference, 'id'>
  ): Observable<LightProtectionReference> {
    return this.httpService
      .request(this.referenceRoute)
      .body(reference)
      .post(environment.backendUrl);
  }

  public putReference(reference: LightProtectionReference): Observable<LightProtectionReference> {
    return this.httpService
      .request(`${this.referenceRoute}`)
      .body(reference)
      .put(environment.backendUrl);
  }

  public deleteReference(referenceId: number): Observable<any> {
    return this.httpService
      .request(`${this.referenceRoute}/${referenceId}`)
      .delete(environment.backendUrl);
  }
}
